import { TapLevel } from './types';

export interface TapLevelCounts {
  level1Taps: number;
  level2Taps: number;
  level3Taps: number;
}

export function addAcceptedTapsByLevel(
  counts: TapLevelCounts,
  accepted: number,
  level: TapLevel
): TapLevelCounts {
  if (accepted <= 0) return { ...counts };

  switch (level) {
    case 1:
      return { ...counts, level1Taps: counts.level1Taps + accepted };
    case 2:
      return { ...counts, level2Taps: counts.level2Taps + accepted };
    case 3:
      return { ...counts, level3Taps: counts.level3Taps + accepted };
    default:
      throw new Error(`Unsupported tap level: ${level}`);
  }
}
